import { UtilizationFiltersRequest } from '../types/dto/request/utilization-filters-request';
import { PlannerPreferences } from '../types/utilization-filters';
import { mapAssignmentStatusFromDTO, mapAssignmentStatusToDTO } from './assignment-status.mapper';

/**
 * Maps API utilization filters DTO to the filters portion of PlannerPreferences.
 * Note: utilizationBasedOn is not part of the DTO — it is stored separately.
 */
export const mapUtilizationFiltersFromDTO = (
  dto?: UtilizationFiltersRequest
): Omit<PlannerPreferences, 'utilizationBasedOn'> | undefined => {
  if (!dto) {
    return undefined;
  }

  return {
    assignmentStatuses: dto.assignmentStatuses?.map(mapAssignmentStatusFromDTO),
  };
};

/**
 * Maps internal PlannerPreferences type to API utilization filters DTO.
 * Handles the conversion from application domain model to wire format.
 */
export const mapUtilizationFiltersToDTO = (
  filters?: PlannerPreferences
): UtilizationFiltersRequest | undefined => {
  if (!filters) {
    return undefined;
  }

  return {
    assignmentStatuses: filters.assignmentStatuses?.map(mapAssignmentStatusToDTO),
  };
};
